import * as React from "react";
import styled from "styled-components";
import {
  TOPBAR_HEIGHT,
  CONTENT_PADDING,
  SIDEBAR_WIDTH
} from "../../settings/metrics";
import Search from "./Search";
import AccountMenu from "./AccountMenu";

const InnerTopbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: fixed;
  left: ${SIDEBAR_WIDTH}px;
  right: 0;
  padding: 0 ${CONTENT_PADDING}px;
  height: ${TOPBAR_HEIGHT}px;
  z-index: 100;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
`;

const Topbar = props => (
  <div {...props} style={{ flex: `0 0 ${TOPBAR_HEIGHT}px` }}>
    <InnerTopbar>
      <Search />
      <AccountMenu style={{ marginLeft: 12 }} />
    </InnerTopbar>
  </div>
);

export default Topbar;



// WEBPACK FOOTER //
// ./src/components/topbar/Topbar.js